import { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function Campanhas({ isadmin }) {
  const [veiculos, setveiculos] = useState([]);
  const [kmsugerido, setkmsugerido] = useState(0);
  const [modotransicao, setmodotransicao] = useState(false);
  const [loading, setloading] = useState(false);
  const [veiculoselecionado, setveiculoselecionado] = useState('');

  useEffect(() => {
    const buscarveiculos = async () => {
      const { data, error } = await supabase
        .from('cadastro_veiculos')
        .select('id, placa, modelo');
      
      if (!error) setveiculos(data || []);
    };
    buscarveiculos();
  }, []);

  const handleveiculochange = async (id) => {
    setveiculoselecionado(id);
    if (!id) {
      setkmsugerido(0);
      return;
    }

    const { data } = await supabase
      .from('cadastro_campanhas')
      .select('km_final')
      .eq('veiculo_id', id)
      .eq('status', 'concluida')
      .order('created_at', { ascending: false })
      .limit(1);

    if (data && data.length > 0) {
      setkmsugerido(data[0].km_final);
    } else {
      setkmsugerido(0); 
    }
  };

  const handlesalvarrota = async (e) => {
    e.preventDefault();
    setloading(true);
    const fd = new FormData(e.target);

    const { error } = await supabase.from('cadastro_campanhas').insert([{
      veiculo_id: veiculoselecionado,
      data_inicial: new Date().toISOString(),
      campanha_realizada: fd.get('campanha_realizada'),
      nome_contato: fd.get('nome_contato'),
      endereco_destino: fd.get('endereco_destino'),
      km_inicial: parseFloat(kmsugerido),
      justificativa_transicao: modotransicao ? fd.get('justificativa') : null,
      status: 'em_rota'
    }]);

    if (!error) {
      alert("✅ Registro gravado com sucesso no banco de dados!");
      e.target.reset();
      setkmsugerido(0);
      setveiculoselecionado('');
      setmodotransicao(false);
    } else {
      alert("❌ Erro ao gravar no banco: " + error.message);
    }
    setloading(false);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border border-gray-100 no-print">
        <header className="border-b pb-4 mb-6">
          <h2 className="text-2xl font-black text-blue-900 uppercase tracking-tight">🚚 Nova Campanha / Rota</h2>
          <p className="text-xs text-gray-500 font-bold italic underline">Controle de Frota Fundo Social Mirassol</p>
        </header>

        <form onSubmit={handlesalvarrota} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            <div className="md:col-span-2">
              <label className="text-[10px] font-black text-gray-400 uppercase ml-1">Veículo Utilizado</label>
              <select 
                className="input-field" 
                onChange={(e) => handleveiculochange(e.target.value)}
                value={veiculoselecionado}
                required
              >
                <option value="">selecione o veículo...</option>
                {veiculos.map(v => (
                  <option key={v.id} value={v.id}>{v.modelo} - placa: {v.placa}</option>
                ))}
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="text-[10px] font-black text-gray-400 uppercase ml-1">Campanha Realizada</label>
              <input 
                name="campanha_realizada" 
                className="input-field" 
                required 
                placeholder="Ex: Entrega de cestas básicas" 
              />
            </div>

            <div>
              <label className="text-[10px] font-black text-blue-900 uppercase ml-1">Km Inicial (Automático)</label>
              <input 
                type="number" 
                value={kmsugerido} 
                readOnly 
                className="input-field bg-gray-100 font-bold text-blue-900 cursor-not-allowed" 
              />
            </div>

            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase ml-1">Responsável no Local</label>
              <input name="nome_contato" className="input-field" required placeholder="Nome do contato" />
            </div>

            <div className="md:col-span-2">
              <label className="text-[10px] font-black text-gray-400 uppercase ml-1">Endereço Completo</label>
              <textarea name="endereco_destino" className="input-field h-20" required placeholder="Rua, número, bairro - Mirassol/SP" />
            </div>
          </div>

          <div className="bg-orange-50 p-4 rounded-2xl border border-orange-100">
            <label className="flex items-center gap-2 cursor-pointer mb-2">
              <input 
                type="checkbox" 
                checked={modotransicao} 
                onChange={(e) => setmodotransicao(e.target.checked)} 
              />
              <span className="text-xs font-bold text-orange-700 uppercase tracking-tighter">Ajuste de Odômetro (Registro de Transição)?</span>
            </label>
            {modotransicao && (
              <textarea 
                name="justificativa" 
                className="input-field h-20 text-xs border-orange-200" 
                required
                placeholder="Justifique o lançamento manual."
              />
            )}
          </div>

          <button 
            disabled={loading}
            className="w-full bg-blue-700 hover:bg-blue-800 text-white font-black py-4 rounded-2xl shadow-xl transition-all active:scale-95"
          >
            {loading ? "Gravando..." : "Gravar Registro"}
          </button>
        </form>
      </div>
    </div>
  );
}

        
